module.exports = __webpack_public_path__ + "0af5d249/img/SOURCERY_poweredby_web.9819842b.png";